import React, { useContext } from 'react';

import ReactQuill from 'react-quill';
import Draggable from 'react-draggable';
import 'react-quill/dist/quill.bubble.css';
import { ThemeContext } from "../Layout/Theme/ThemeContext";
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
function EmailPreviewModal({ onClose, subject = "", description = "", footer = "", to = "", cc = "", }) {
    const handleStart = (e, ui) => {
        e.stopPropagation();
    };
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";
    const emailContent = description + "<br><br>" + footer;

    return (
        <div className="modal fade emailPrevieewModal show d-block" id="emailPrevieewModal" tabIndex="-1" aria-labelledby="emailPrevieewModalLabel" aria-hidden="true" data-backdrop="static">
            <div className="modal-dialog modal-md" style={{ width: "600px" }}>
                <Draggable handle=".modal-header" onStart={handleStart}
                bounds={{ top: 0, bottom: window.innerHeight - 400 }}>
                    <div className="modal-content">
                        <div className={`modal-header ${accordTheme}`}>
                            <h5 className="modal-title" id="largeModalLabel">Email Preview</h5>
                            <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                <label htmlFor="To" className="col-sm-2 col-form-label">To:</label>
                                <div className="col-sm-10">
                                    <input type="text" className="form-control" name="To" value={to} readOnly />

                                </div>
                            </div>
                            <hr />
                            <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                <label htmlFor="cc" className="col-sm-2 col-form-label">Cc:</label>
                                <div className="col-sm-10">
                                    <input type="text" className="form-control" name="cc" value={cc} readOnly />

                                </div>
                            </div>
                            <hr />
                            <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                <label htmlFor="subject" className="col-sm-2 col-form-label">Subject:</label>
                                <div className="col-sm-10">
                                    <input type="text" className="form-control" name="subject" value={subject} readOnly />

                                </div>
                            </div>
                            <hr />
                            <div className="row mb-3" style={{ marginLeft: "5px", marginRight: "0px", minHeight: "150px", maxHeight: "300px", overflowY: "auto" }}>
                                <SunEditor
                                    setContents={emailContent}
                                    setOptions={{
                                        height: 250, // preview height
                                        readonly: true, // make editor read-only
                                        toolbar: false, // hide toolbar
                                        resizingBar: false,
                                        buttonList: [], // no buttons
                                    }}
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary btn-sm" onClick={onClose}>
                                Close
                            </button>
                        </div>
                    </div>
                </Draggable>
            </div>
        </div>
    );
}

export default EmailPreviewModal;
